import { axiosUnos } from "../axios/unos_axios";

export type PositionAddParams = {
  datum: Date;
  title: string;
  fileName: string;
};

export type PositionSearchParams = {
  skip?: number;
  limit?: number;
};

export const positionAdd = async ({
  datum,
  title,
  fileName,
}: PositionAddParams): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosUnos.post("position", { datum, title, fileName });
  } catch (error) {}
  if (response && response.status === 201) {
    result = response.data;
  }

  return result;
};

const positionResponseFormat = (position: any): any => {
  const result = { ...position, datum: new Date(position.datum) };

  return result;
};

export const positionGet = async (id: string): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosUnos.get(`position/${id}`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result = positionResponseFormat(result);
  }

  return result;
};

export const positionSearch = async (
  searchParams?: PositionSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosUnos.post(`position/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) =>
      positionResponseFormat(item)
    );
  }

  return result;
};

export const positionUpdate = async (
  id: string,
  updatePayload: any
): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosUnos.put(`position/${id}`, updatePayload);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export const positionDelete = async (id: string): Promise<boolean> => {
  let result: boolean = false;
  let response: any;
  try {
    response = await axiosUnos.delete(`position/${id}`);
    result = true;
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};
